import { useRequest } from '@byted/hooks';
import { Toast } from '@douyinfe/semi-ui';
import { useParams } from '@jupiter/plugin-runtime/router';
import { forumPostService } from '@/api/forumPost';
import { forumpost } from '@/typings/open.platform.forum_bff';
import { toastError } from '@/utils/toastError';
import useBiz from '@/context/useBiz';

const fetcher = async (params: forumpost.GetPostRequest) => {
  try {
    const res = await forumPostService.getPost(params);
    if (res.error) {
      throw new Error(res.message);
    }
    return res.data;
  } catch (e) {
    toastError(e);
  }
  return undefined;
};

export function usePost() {
  const biz = useBiz(s => s.biz);
  const { postId } = useParams<{
    postId: string;
  }>();

  const {
    data: postDetail,
    run: fetchPost,
    loading,
  } = useRequest(fetcher, {
    auto: true,
    defaultParams: [
      {
        Biz: biz,
        PostId: postId,
      },
    ],
    ready:
      Boolean(postId) &&
      Boolean(biz) &&
      // Trick 销毁社区子应用后不发起请求
      window.location.pathname.includes('forum'),
    onError() {
      Toast.error('获取文章内容失败');
    },
  });

  return {
    postDetail,
    fetchPost,
    fetchingPost: loading,
  };
}
